// Thông báo kết quả: toast góc phải dưới (§19 luật 6). Gọi từ bất kỳ đâu bằng baoToast("Đã lưu", "ok" | "err" | "warn").
// Dùng chung kho toastStore với pilot; giao diện mới (ui.css .toasts / .toast).
import { useEffect, useState } from "react";
import { layToast, ngheToast, type MucToast } from "./toastStore";

export function Toasts() {
  const [ds, setDs] = useState<MucToast[]>(layToast);
  useEffect(() => ngheToast(setDs), []);
  return (
    <div className="toasts" role="status" aria-live="polite">
      {ds.filter((t) => t.hien).map((t) => (
        <div key={t.id} className={"toast" + (t.kind === "ok" ? "" : " " + t.kind)}>{t.text}</div>
      ))}
    </div>
  );
}
